<template>
    <div>
        <div class="features-zone features-panel commands">

            <div class="feature-item">
                <base-button type="secondary"
                        class="btn-icon-only rounded-circle mr-0"
                        @click="createOrUpdateNote">
                    <span class="btn-inner--icon"><i class="fas fa-edit"></i></span>
                    <span class="badge badge-md badge-circle badge-floating badge-warning"
                            v-if="stats && stats.global.notes">
                        {{ stats.global.notes }}
                    </span>
                </base-button>
            </div>

            <div class="feature-item" v-if="goDefined">
                <div class="go-status" :class="goClass">
                    {{ goStatus }}
                </div>
            </div>
        </div>

        <portal to="modals">

            <form-modal v-model="modals.editNote"
                :title="$t('dashboard.general-comment')"
                :loading="noteForm.loading"
                size="xl"
                :centered="false"
            >
                <note-form v-model="noteForm.data"
                    :errors="noteForm.errors"
                    :modal="modals.editNote"
                    :features="features"
                >
                </note-form>
            </form-modal>

        </portal>
    </div>
</template>

<script>
    import ModalsController from '@trax/classes/ModalsController'
    import CrudForm from '@trax/classes/CrudForm'
    import CrudClient from '@trax/classes/CrudClient'
    import NoteForm from '../../log/NoteForm'

    export default {

        components: {
            NoteForm,
        },

        props: {

            session: {
                type: Object,
                default: null
            },

            stats: {
                type: Object,
                default: null
            },

            features: {
                default: null
            },
        },

        data() {
            return {
                noteForm: new CrudForm(
                    new CrudClient(
                        '/socrates/api/front/dashboard/data/context/session/feedbacks',
                        {
                            registration_id: this.session.registration_id,
                            simulation_id: this.session.simulation_id,
                            session_id: this.session ? this.session.id : null
                        }
                    ),
                    this.mapNote,
                    this.unmapNote
                ),
                modals: new ModalsController(['editNote']),
            }
        },

        created() {
            this.noteForm.init(this, 'noteForm')
            this.modals.init(this, 'modals')
        },

        computed: {

            goStatus() {
                if (!this.stats) {
                    return ''
                }
                if (this.stats.global.gonogo == 'go') {
                    return 'GO'
                }
                return 'NO GO'
            },

            goClass() {
                if (!this.goDefined) {
                    return 'bg-gray'
                }
                if (this.stats.global.gonogo == 'go') {
                    return 'bg-success'
                }
                return 'bg-danger'
            },

            goDefined() {
                return this.stats && this.stats.global.progress_status != 'not-attempted'
            }
        },

        methods: {
            
            createOrUpdateNote() {
                this.modals.open('editNote')
                this.noteForm.update(0).then(resp => {
                    this.modals.close('editNote')
                    this.$emit('reload-stats')
                })
            },

            mapNote(feedback) {
                return {
                    id: feedback ? feedback.id : null,
                    description: feedback ? feedback.description : null,
                }
            },

            unmapNote(data, type) {
                data.type = 'note'
                data.registration_id = this.session.registration_id
                data.simulation_id = this.session.simulation_id
                data.session_id = this.session ? this.session.id : null
                data.timeslot_id = null
                return data
            },
        }
    }
</script>

<style scoped>

    .features-zone {
        position: fixed;
        z-index: 900;
        width: 70px;
    }
    .features-panel {
        background-color: #fff;
        box-shadow: 0 0 2rem 0 rgba(136, 152, 170, .15);
        border-radius: 0.5rem;
        text-align: center;
    }
    .features-panel >>> button .badge {
        border: none;
        width: 1.4rem;
        height: 1.4rem;
    }

    .commands {
        top: 78px;
        padding: 15px 0 15px 0;
    }
    .commands button {
        background-color: #fff;
        box-shadow: none;
        border-color: #fff;
    }
    .commands button:active, .commands button:active:focus {
        border: none;
        box-shadow: none !important;
    }
    .commands .go-status {
        color: white;
        border-radius: .5rem;
        padding: 5px;
        margin: 10px 10px -4px 10px;
        line-height: 1.2rem;
        min-height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

</style>
